import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { ResponseComboSendingServer } from './interfaces/email.interface';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class GestionEmailService {

    constructor(private http: HttpClient) { }

    getData(url: string, params: object): Observable<any> {
        return this.http.post<any>(url, params);
    }

    updateData(url: string, params: object): Observable<any> {
        return this.http.post<any>(url, params, httpOptions);
    }

    updateTemplates(url: string, params: object): Observable<any> {
        return this.http.post<any>(url, params, httpOptions);
    }

    getComboSendingServer(): Observable<any> {
        return this.http.post<any>(`${environment.ENTORNO}${environment.SessionService.PANELCONTROL.GESTION_EMAIL.urlComboSendingServer}`, {}, httpOptions);
    }

    getComboTypeEmail(): Observable<any> {
        return this.http.post<any>(`${environment.ENTORNO}${environment.SessionService.PANELCONTROL.GESTION_EMAIL.urlComboTypeEmail}`, {}, httpOptions);
    }

    getSmtpConfiguration(): Observable<any> {
        return this.http.post<any>(`${environment.ENTORNO}${environment.SessionService.PANELCONTROL.GESTION_EMAIL.urlgetAll}`, {}, httpOptions);
    }

}
